import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { minimumNumberOfLines } from './SummaryContent';

const classes = {
	flex: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	form: {
		marginY: 0.5,
	},
	icons: {
		marginLeft: 1,
		color: 'rgba(0, 0, 0, 0.54)',
	},
};

const RecommendationSummary = ({ data, viewAll }) => {
	const { t } = useTranslation(['candidate-feedback']);
	const [slicedData, setSlicedData] = React.useState([]);

	React.useEffect(() => {
		if (viewAll) {
			const allData = [...data];
			setSlicedData(allData);
		} else {
			const smallerDataSet = data.slice(0, minimumNumberOfLines);
			setSlicedData(smallerDataSet);
		}
	}, [data, viewAll]);

	return React.Children.toArray(
		slicedData.map((form, index) => (
			<Box sx={classes.flex}>
				<Box>
					<Typography variant="body1">
						{form.formName}{' '}
						<span className="screenreader">
							:{' '}
							{t('recommendation_count', {
								count: form.recommendedCount,
								total: form.totalCount,
							})}
						</span>
					</Typography>
				</Box>
				<Box sx={classes.flex} marginLeft={2} aria-hidden="true">
					<Typography
						variant="body1"
						sx={classes.form}
						id={`form-${index}`}
						aria-label={t('recommendation_count', {
							count: form.recommendedCount,
							total: form.totalCount,
						})}
					>
						{form.recommendedCount}/{form.totalCount}
					</Typography>
					<ThumbUpIcon sx={classes.icons} fontSize="small" aria-labelledby={`form-${index}`} />
				</Box>
			</Box>
		)),
	);
};

export default RecommendationSummary;
